import { Box, Stack } from '@mui/material';
import { GridDensity, GridToolbarContainer } from '@mui/x-data-grid';
import { FC, memo } from 'react';
import { ToolbarActionGroup } from 'src/components/ui/actionGroup/actionGroupButtons';
import { CreateButton } from 'src/components/ui/actionGroup/CreateButton';
import { ExportButton } from 'src/components/ui/actionGroup/ExportButton';

import MyGridToolbarColumnsButton from '../common/MyGridToolbarColumnsButton';
import MyGridToolbarDensitySelector from '../common/MyGridToolbarDensitySelector';
import FilterPanelToolbarFilterButton from '../common/MyGridToolbarFilterButton';

const CustomToolbar: FC<{
  toggleDialogIsOpen: () => void;
  handleDownloadCSV: () => void;
  density: GridDensity;
  onDensityChange: (density: GridDensity) => void;
}> = memo(({ toggleDialogIsOpen, handleDownloadCSV, density, onDensityChange }) => (
  <GridToolbarContainer
    sx={{
      width: '100%'
    }}
  >
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        flexWrap: 'wrap',
        gap: 1
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <FilterPanelToolbarFilterButton />
        <MyGridToolbarColumnsButton />
        <MyGridToolbarDensitySelector
          density={density}
          onDensityChange={onDensityChange}
        />
      </Stack>
      <ToolbarActionGroup>
        <ExportButton onClick={handleDownloadCSV} label="エクスポート" />
        <CreateButton onClick={toggleDialogIsOpen} label="グループ追加" />
      </ToolbarActionGroup>
    </Box>
  </GridToolbarContainer>
));

export default CustomToolbar;
